import React from 'react';
import styled, { keyframes } from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';
import { useMuPDF } from './common/mupdf-context';

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  z-index: 100;
  transition: opacity 0.4s ease;

  &.hiding {
    animation: ${fadeOut} 0.4s ease forwards;
    pointer-events: none;
  }
`;

const Label = styled.p`
  margin-top: 16px;
  font-family: Raleway, sans-serif;
  font-size: 14px;
  color: #666;
`;

export default function LoadingOverlay() {
  const ctx = useMuPDF();
  const [hiding, setHiding] = React.useState(false);
  const [visible, setVisible] = React.useState(true);

  const loading = !ctx || ctx.loading;

  React.useEffect(() => {
    if (!loading && visible) {
      setHiding(true);
      const t = setTimeout(() => setVisible(false), 400);
      return () => clearTimeout(t);
    }
  }, [loading]);

  if (!visible) return null;

  return (
    <Overlay className={hiding ? 'hiding' : ''}>
      <CircularProgress size={48} thickness={3} sx={{ color: '#999' }} />
      <Label>Loading document…</Label>
    </Overlay>
  );
}
